import "./TradeInIframeModal.scss"
import React, {useEffect, useRef} from "react"
import Modal from "react-bootstrap/Modal"

const TradeInIframeModal = ({
                              showModal,
                              onClose,
                              iframeSrc,
                              title,
                              skuAndProduct = null
                            }) => {
  const iframeRef = useRef(null)

  useEffect(() => {
    if (!showModal || !skuAndProduct) return

    const iframe = iframeRef.current
    if (!iframe) return

    const handleLoad = () => {
      iframe.contentWindow.postMessage(skuAndProduct, "*")
    }

    iframe.addEventListener("load", handleLoad)

    return () => {
      iframe.removeEventListener("load", handleLoad)
    }
  }, [showModal, skuAndProduct])

  useEffect(() => {
    const handleMessage = (event) => {
      if (
        event.origin === "https://tradein-sit.evollis.com" &&
        event.data?.type === "CLOSE" &&
        event.data?.app === "tradein"
      ) {
        onClose(event.data?.accepted)
      }
    }

    window.addEventListener("message", handleMessage)
    return () => {
      window.removeEventListener("message", handleMessage)
    }
  }, [onClose])

  return (
    <Modal show={showModal} size="xl" centered dialogClassName="tradein-modal">
      <Modal.Body>
        <iframe ref={iframeRef} id="tradeinApp" src={iframeSrc} title={title || "Tradein App"}/>
      </Modal.Body>
    </Modal>
  )
}

export default TradeInIframeModal
